<template>
  <v-col class="register default-slot" md="7" sm="12">
    <div class="top-icons">
      <div class="top-icons">
        <a class="back-icon" v-on:click="changePage(1)">
          <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
        </a>
      </div>
    </div>
    <h1 class="register-title">Dog Information</h1>
    <v-form class="mt-5 mx-10" v-model="isValid">
      <v-row>
        <v-text-field
          outlined
          label="Official Name"
          v-model="dogInfo.officialName"
          :rules="[
            (v) => !!v || 'Official Name is required',
            (v) => !(v.split(' ').filter(s => !!s).length < 2) || 'Official Name must have two words',
            (v) => v.length < 30 || '(30) characters max',
          ]"
        >
          <v-tooltip slot="append" dark right>
            <template v-slot:activator="{on, attrs}">
              <font-awesome-icon
                icon="info-circle"
                color="primary"
                v-bind="attrs"
                v-on="on"
              />&nbsp;
            </template>
            <span>
              &nbsp;This is your dog's official name. Your dog's name must include at least two words.
            </span>
          </v-tooltip>
        </v-text-field>
      </v-row>
      <v-row>
        <v-text-field
          outlined
          label="Call Name"
          v-model="dogInfo.callName"
          :rules="[(v) => !!v || 'Call Name is required']"
        />
      </v-row>
      <v-row>
        <v-col :lg="10" :md="10" :sm="10">
          <v-row>
            <DatepickerFormatted
              :date="dogInfo.birthDate"
              label="Date of Birth"
              v-on:updateDates="updateBirthDate($event)"
              :rules="[
                (v) => !!v || 'Date of birth is required',
                (v) => new Date(v) < new Date() || 'Date of birth cannot be a future date'
              ]"
            />
          </v-row>
          <v-row>
            <v-autocomplete
              v-model="dogInfo.breed"
              label="Breed"
              :items="colors.breeds"
              item-text="description"
              item-value="abbreviation"
              :rules="[(v) => !!v || 'Breed is required']"
            />
          </v-row>
        </v-col>
        <v-col :lg="2" :md="2" :sm="2">
          <v-radio-group
            v-model="dogInfo.gender"
            label="Gender"
            :rules="[(v) => !!v || 'Gender is required']"
          >
            <v-radio
              key="M"
              label="Male"
              value="M"
            />
            <v-radio
              key="F"
              label="Female"
              value="F"
            />
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-textarea
          outlined
          auto-grow
          counter
          class="mt-5"
          label="Previous ASCA points earned"
          v-model="dogInfo.previousPointsEarned"
        >
          <v-tooltip slot="append" dark right>
            <template v-slot:activator="{on, attrs}">
              <font-awesome-icon
                icon="info-circle"
                color="primary"
                v-bind="attrs"
                v-on="on"
              />&nbsp;
            </template>
            <span>
              &nbsp;Please enter the Affiliate/Club sponsoring the show, show date, and points earned.
            </span>
          </v-tooltip>
        </v-textarea>
      </v-row>
    </v-form>
    <v-btn
      class="white--text"
      large
      color="primary"
      :dark="isValid"
      :disabled="!isValid"
      v-on:click="changePage(3)"
    >NEXT</v-btn>
    <p class="steps">STEP <b>2</b> OF <b>3</b></p>
    <footer-text />
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";
import lookupsService from "@/services/lookupsService";

import FooterText from "@/components/common/FooterText.vue";
import DatepickerFormatted from '@/components/common/inputs/DatepickerFormatted.vue';

export default Vue.extend({
  name: "DogInformation",
  components: { FooterText, DatepickerFormatted },
  props: {
    changePage: Function,
    dogInfo: Object,
  },
  created: function() {
    this.reloadData();
  },
  data: function () {
    return {
      isValid: false,
      showResults: [] as any[],
      colors: {},
    }
  },
  methods: {
    reloadData: function() {
      lookupsService.getDogsAttributes().then((res) => {
        this.colors = res;
      });
    },
    updateBirthDate: function (val: any) {
      this.dogInfo.birthDate = val.date;
      //workaround to force rerendering after setting up formatted date
      this.$set(this, "showResults", this.showResults);
    },
    getIsValid() {
      return this.isValid && !!this.dogInfo.breed;
    }
  }
});
</script>